<template>
  <v-card flat class="pa-4">
    <!-- Switch to activate Upgrade-Rechner -->
    <v-switch v-model="switchUpgrade" label="Wechsel von GF Abo zu Kombi Card" class="mb-4" @change="onSwitchChange" />

    <!-- Dialog mit Erklaerung und Preis-Eingabe -->
    <v-dialog v-model="showDialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline">Hinweis zum Upgrade</v-card-title>
        <v-card-text>
          <p>
            Bitte gib den Abo-Preis (ohne Zusatzpakete) deines bestehenden Group Fitness Abos ein. Dieser Rechner berechnet nur die Kostendifferenz
            des Upgrades. Zusatzpakete werden nach dem Upgrade und Aktivierung des Vertrags im TAC über die Upgrade-Funktion hinzugefügt. Bestehende
            Zusatzpakete bitte nicht im GF Abo Preis berücksichtigen – sie werden übernommen (bereits bezahlt).
          </p>
          <v-text-field v-model.number="preisGroupAbo" label="Preis GF Abo (ohne Zusatzpakete)" prefix="CHF" type="number" min="0" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="confirmDialog">Ich verstehe</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Upgrade-Rechner, nur sichtbar nach Bestätigung -->
    <template v-if="switchUpgrade && dialogConfirmed">
      <v-form>
        <v-row dense>
          <!-- Preis Kombi-Abo (extern) -->
          <v-col cols="12" md="4">
            <v-text-field :value="preisKombiAbo.toFixed(2)" label="Preis Kombi Abo" prefix="CHF" readonly />
          </v-col>

          <!-- Datum Abschluss -->
          <v-col cols="12" md="4">
            <v-text-field v-model="dateAbschluss" label="Datum Abschluss" type="date" />
          </v-col>

          <!-- Datum Kündigung -->
          <v-col cols="12" md="4">
            <v-text-field v-model="dateKuendigung" label="Datum Kuendigung" type="date" />
          </v-col>

          <!-- Vertragsenddatum (extern) -->
          <v-col cols="12" md="4">
            <v-text-field :value="vertragsEndDatum" label="Vertragsenddatum" type="date" readonly />
          </v-col>

          <!-- Anzahl Tage -->
          <v-col cols="12" md="4">
            <v-text-field :value="anzahlTage" label="Anzahl Tage (Rest)" suffix="Tage" readonly />
          </v-col>

          <!-- Guthaben Kombi -->
          <v-col cols="12" md="4">
            <v-text-field :value="guthabenKombi.toFixed(2)" label="Guthaben Kombi" prefix="CHF" readonly />
          </v-col>

          <!-- Kosten Restlaufzeit -->
          <v-col cols="12" md="4">
            <v-text-field :value="kostenRestlaufzeit.toFixed(2)" label="Kosten Restlaufzeit" prefix="CHF" readonly />
          </v-col>

          <!-- Preisdifferenz hervorgehoben -->
          <v-col cols="12" md="4">
            <v-text-field :value="preisdifferenz.toFixed(2)" label="Preisdifferenz" prefix="CHF" readonly color="primary" class="font-weight-bold" />
          </v-col>
        </v-row>
      </v-form>
    </template>
  </v-card>
</template>

<script>
export default {
  name: "contractUpgradeCalculator",
  props: {
    preisKombiAbo: {
      type: Number,
      required: true,
    },
    vertragsEndDatum: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      preisGroupAbo: null,
      dateAbschluss: this.$moment("2024-06-26").format("YYYY-MM-DD"),
      dateKuendigung: this.$moment("2024-06-26").subtract(1, "day").format("YYYY-MM-DD"),
      switchUpgrade: false,
      showDialog: false,
      dialogConfirmed: false,
    }
  },
  methods: {
    onSwitchChange(val) {
      if (val) {
        this.showDialog = true
      } else {
        this.dialogConfirmed = false
      }
    },
    confirmDialog() {
      this.dialogConfirmed = true
      this.showDialog = false
    },
    roundToFiveCents(value) {
      return Math.round(value / 0.05) * 0.05
    },
  },
  computed: {
    anzahlTage() {
      const dK = this.$moment(this.dateKuendigung)
      const dE = this.$moment(this.vertragsEndDatum)
      const diff = dE.diff(dK, "days")
      return diff > 0 ? diff : 0
    },
    kostenRestlaufzeit() {
      if (this.anzahlTage <= 0) return 0
      const raw = (this.preisKombiAbo * this.anzahlTage) / 365
      return this.roundToFiveCents(raw)
    },
    guthabenKombi() {
      if (this.anzahlTage <= 0) return 0
      const raw = (this.preisGroupAbo * this.anzahlTage) / 365
      return this.roundToFiveCents(raw)
    },
    preisdifferenz() {
      return this.kostenRestlaufzeit - this.guthabenKombi
    },
  },
}
</script>

<style scoped>
/* Optional: weitere Styles */
</style>
